"use client";

import { bookingQueryKeys } from "@/app/modules/booking/hooks/useBookingQueries";
import { SalonSetupFields } from "./SalonSetupFields";
import { createSalonInput, resolveSalonSelections, validSalonSetup, validSalonStaff } from "./salonSetup";
import type { IndustrySetupDriver } from "./types";

export const hairSalonSetup: IndustrySetupDriver = {
  presetCode: "hair-salon",
  titleKey: "apps.presets.items.hairSalon.title",
  defaultNameKey: "hairSalon.defaultName",
  displayNameLabelKey: "hairSalon.salonName",
  usePersonalName: false,
  descriptionKey: "hairSalon.description",
  completionLabelKey: "hairSalon.complete",
  setupSteps: ["hairSalon.team", "hairSalon.services", "hairSalon.review"],
  defaultInput: {},
  createInput: createSalonInput,
  isValid: validSalonSetup,
  isStepValid: (input, step) => Boolean(input.installOnly) || (step === 0 ? validSalonStaff(input.salonSetup) : validSalonSetup(input)),
  prepareInput: (input) => input.installOnly ? { ...input, salonSetup: undefined } : input,
  requiredRecommendedApps: [],
  Fields: SalonSetupFields,
  resolveSelections: resolveSalonSelections,
  destination: (workspaceUuid, result) => result.completed && result.bookingPortalUuid
    ? `/c/${workspaceUuid}/booking/${result.bookingPortalUuid}`
    : `/c/${workspaceUuid}/apps/presets`,
  invalidationKeys: (workspaceUuid) => [bookingQueryKeys.all(workspaceUuid)],
};
